import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1NiwelacjaTerenu from "../../components/offer/1niwelacjaTerenu";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Niwelacja terenu i przygotowanie działki pod budowę | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Niwelacja terenu i przygotowanie działki pod budowę | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Precyzyjna niwelacja terenu, skarpowanie i profilowanie działek pod budowę domów oraz ogrody. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i woj. pomorskim."
          key="desc"
        />
        <meta
          property="og:title"
          content="Niwelacja terenu i przygotowanie działki pod budowę | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Precyzyjna niwelacja terenu, skarpowanie i profilowanie działek pod budowę domów oraz ogrody. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i woj. pomorskim."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1NiwelacjaTerenu />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
